import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three';

export function Model(props) {
  const { nodes, materials } = useGLTF('/models/PLD_AdAstra_Planet.glb')
  const holoSignRef = useRef()

 
  materials.M_HoloSign.emissive = materials.M_HoloSign.color
  materials.M_HoloSign.emissiveIntensity = 25
  materials.M_HoloSign.transparent = true
  materials.M_HoloSign.alphaHash = true


  // Animate the Holo_Sign rotation on Y-axis
  useFrame((state, delta) => {
    if (holoSignRef.current) {
      holoSignRef.current.rotation.y += delta * 0.2 // Rotate at 0.5 radians per second
    }
  })

  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="AdAstra_Planet"
          castShadow
          receiveShadow
          geometry={nodes.AdAstra_Planet.geometry}
          material={materials.M_Planet}
          scale={0.183}
        />
        <mesh
          ref={holoSignRef}
          name="Holo_Sign"
          
          geometry={nodes.Holo_Sign.geometry}
          material={materials.M_HoloSign}
          rotation={[-Math.PI / 3.25, -Math.PI / 3, 0]}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/PLD_AdAstra_Planet.glb')

